import axios from "axios";
import { convertToPageable, extractData, handleApiException, handleResponse } from "helpers/apiResponseHelper";
import { apiService } from "services/api.service";
import { ElectricityAgreementRenewalPlanFilters } from "./models";

async function getAgreementRenewalPlans(pageRequest: any) {
    return axios.get(apiService.getApiUrl() + '/electricity/agreement-renewal-plans/admin', {
        params: pageRequest
    }).then(handleResponse).then(convertToPageable).catch(handleApiException);
}

export interface UpdateAgreementRenewalPlanRequest {
  electricityPackageId: number;
  basePriceCentsKwh?: number;
  dayTariffCentsKwh?: number;
  nightTariffCentsKwh?: number;
  monthlyFeeEuros?: number;
  consumptionMarginalCentsKwh: number;
  productionMarginalCentsKwh?: number;
  contractPeriodId: number;
}

async function updateAgreementRenewalPlan(agreementRenewalPlanId: number, request: UpdateAgreementRenewalPlanRequest) {
  return axios.put(apiService.getApiUrl() + `/electricity/agreement-renewal-plans/admin/${agreementRenewalPlanId}`, request)
    .then(handleResponse).then(extractData);
}

export interface UpdateAgreementRenewalPlanByIdsRequest {
  data: UpdateAgreementRenewalPlanRequest;
  agreementRenewalPlanIds: number[];
}

async function updateAgreementRenewalPlanByIds(request: UpdateAgreementRenewalPlanByIdsRequest) {
  return axios.put(apiService.getApiUrl() + `/electricity/agreement-renewal-plans/admin/ids`, request)
    .then(handleResponse).then(extractData);
}

export interface UpdateAgreementRenewalPlanByFilterRequest {
  data: UpdateAgreementRenewalPlanRequest;
  filter: ElectricityAgreementRenewalPlanFilters;
  excludedAgreementRenewalPlanIds: number[];
}

async function updateAgreementRenewalPlanByFilter(request: UpdateAgreementRenewalPlanByFilterRequest) {
  return axios.put(apiService.getApiUrl() + `/electricity/agreement-renewal-plans/admin/filter`, request)
    .then(handleResponse).then(extractData);
}

async function cancelAgreementRenewalPlan(agreementRenewalPlanId: number) {
  return axios.post(apiService.getApiUrl() + `/electricity/agreement-renewal-plans/admin/${agreementRenewalPlanId}/cancel`, {})
    .then(handleResponse).then(extractData);
}


export const ElectricityAgreementRenewalPlansService = {
    getAgreementRenewalPlans,
    updateAgreementRenewalPlan,
    updateAgreementRenewalPlanByIds,
    updateAgreementRenewalPlanByFilter,
    cancelAgreementRenewalPlan
};